module.exports = __webpack_public_path__ + "resources/img/img_maxgauge4.f9adda1032230127acb3cf9ea797d532.png";